<div class="detail-dataset-view">
  <div class="background">
    <div class="view-header">
      <div class="table-name">{{ dataSet.tableName }}</div>
      <div class="table-heading">Column Description</div>
      <div class="close-icon">
        <img
          src="..\..\..\..\..\assets\icons\svg\x-circle.svg"
          alt="close"
          (click)="closeDialog()"
          (keydown)="closeDialog()"
        />
      </div>
    </div>
    <div class="view-content">
      <ng-container
        *ngIf="dataSet?.tableDetails?.Columns?.length > 0; else noData"
      >
        <table class="table-layout">
          <thead>
            <tr class="row-layout">
              <th class="table-heading">Column Name</th>
              <th class="table-heading">Type</th>
              <th class="table-heading">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="row-layout"
              *ngFor="let row of dataSet?.tableDetails?.Columns"
            >
              <td class="table-content">{{ row["Name"] }}</td>
              <td class="table-content">{{ row["DataType"] }}</td>
              <td class="table-content">
                {{
                  row["Description"] == "nan" || row["Description"] == ""
                    ? "Description not available"
                    : row["Description"]
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-template #noData>
        <div class="no-data">
          No column information available for this table.
        </div>
      </ng-template>
    </div>
  </div>
</div>
